'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setComponentInfoForDevTool = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileOverview 组件的公共属性
                                                                                                                                                                                                                                                                               */


var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _spauiDevtool = require('@tencent/spaui-devtool');

var _index = require('../type/index');

var _index2 = require('../object/index');

var _index3 = require('../array/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 获取实例id，记录在window
var getId = function getId() {
    var result = 1000;

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window) {
        if (typeof window.__SPAUI_DEVTOOL_ID__ === 'undefined') {
            window.__SPAUI_DEVTOOL_ID__ = result;
        }
        window.__SPAUI_DEVTOOL_ID__ += 1;
        result = window.__SPAUI_DEVTOOL_ID__;
    }

    return result;
};

// 设置开发环境
var setComponentInfoForDevTool = exports.setComponentInfoForDevTool = function setComponentInfoForDevTool() {
    var componentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var componentProps = arguments[1];
    var name = componentClass.name,
        componentName = componentClass.componentName,
        version = componentClass.version,
        componentVersion = componentClass.componentVersion,
        defaultProps = componentClass.defaultProps;

    var theName = componentName || name || '';
    var theVersion = version || componentVersion || '';
    var componentInfo = {
        name: theName,
        version: theVersion
    };
    var componentString = componentInfo.name + '@' + componentInfo.version;
    var result = _extends({}, componentInfo),
        key = '',
        componentInfomation = {};

    // 将调试信息存储在window下
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window && theName && componentProps) {
        componentInfomation = (0, _spauiDevtool.getComponentInfomation)(componentInfo, componentProps, defaultProps);

        if (componentInfomation && componentInfomation.name) {
            // 节点信息存放在该变量内
            if (!window.__SPAUI_DEVTOOL__) {
                window.__SPAUI_DEVTOOL__ = {};
            }
            // 页面版本信息存放在该变量内
            if (!window.__SPAUI_DEVTOOL_COMPONENTS__) {
                window.__SPAUI_DEVTOOL_COMPONENTS__ = [];
            }

            if ((0, _index3.indexOf)(window.__SPAUI_DEVTOOL_COMPONENTS__, componentString) < 0) {
                window.__SPAUI_DEVTOOL_COMPONENTS__.push(componentString);
            }

            // 生成唯一ID
            key = 'spaui_devtool_element_key_' + getId();
            componentInfomation.string = (0, _spauiDevtool.showComponentInfomation)(componentInfo, componentProps, defaultProps);
            window.__SPAUI_DEVTOOL__[key] = componentInfomation;

            result.key = key;
            result.infomation_path = 'window.__SPAUI_DEVTOOL__.' + key;
        }
    }

    // 返回组件名称与版本
    return JSON.stringify(result);
};

/**
 * 获取组件默认支持的一些属性
 * @param {Object} props 组件props
 * @param {Object} config 特定配置
 * @param {String} config.className 组件自定义的一些className
 * @param {Object} config.style     组件自定义的一些style样式
 * @param {String} config.id        组件自定义id
 * @param {Boolean} config.needTitle 是否需要返回title
 * @param {Array} config.events 支持的事件
 * @param {Boolean} config.supportAllEvents 是否支持所有的事件
 * @param {Object} [componentClass] 组件class
 * @param {Object} [componentClassProps] 组件当前的props数据
 * @return {Object}                 组件公共的一些组件特性
 */
var globalProps = function globalProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var componentClass = arguments[2];
    var componentClassProps = arguments[3];
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;

    var allEvents = ['onKeyPress', 'onKeyUp', 'onKeyDown', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onClick'];
    var events = (0, _index.isArray)(config.events) && config.events.length > 0 ? config.events : config.supportAllEvents ? allEvents : [];
    var data = {},
        key = '',
        devInfo = '';

    for (key in props) {
        if (key.indexOf('data-') === 0 || key === 'accessKey' || key === 'dir' || key === 'draggable' || key === 'tabIndex' || key === 'title' && config.needTitle || key === 'defaultValue' && typeof props[key] !== 'undefined' || key === 'defaultChecked' && typeof props[key] !== 'undefined') {
            data[key] = props[key];
        } else if (key === 'htmlRef' || key === 'htmlref') {
            data.ref = props[key];
        }
    }

    data.className = (0, _classnames2.default)(className, config.className, 'spaui-component');
    data.id = id || config.id;
    data.style = (0, _index2.objectAssign)((0, _index2.objectAssign)({}, config.style), style);

    // 支持操作事件
    events.map(function (item) {
        if (item) {
            data[item] = props[item];
        }
        return item;
    });

    // 在dom结构上设置开发信息
    devInfo = setComponentInfoForDevTool(componentClass, componentClassProps || props);
    if (devInfo) {
        data['data-spaui'] = devInfo;
    }

    return data;
};

exports.default = globalProps;